module.exports = __webpack_public_path__ + "f195971dae19a52db6471a4fbba082a7.svg";